import PropTypes from "prop-types";
import ClearwaysDeviceSettingsForm from "./form";

import groupAPI from "services/api/groups";
import sitesAPI from "services/api/sites";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { wrapper } from "utils/wrapper";
import { processGroupData } from "utils/group";

import { processDeviceData } from "utils/device";
import { useSoftUIController } from "hooks/context";

function ClearwaysDeviceSettings({ uuid, selected_device }) {

    groupAPI.loadToken(useAuth0());
    sitesAPI.loadToken(useAuth0());

    const [controller] = useSoftUIController();
    const { selectedOrg, userPermissions } = controller;

    const showAdvancedDeviceLevel = userPermissions.indexOf('devices-advanced:view') >= 0;

    const sites = useQuery({
        queryKey: ['getAllSites', selectedOrg],
        queryFn: async () => {
            return await sitesAPI.getAllSites();
        }
    });

    const groups = useQuery({
        queryKey: ['getAllGroups', selectedOrg],
        queryFn: async () => {
            return await groupAPI.getAllGroups();
        }
    });

    const group = useQuery({
        queryKey: ['getGroupWithDeviceUUID', uuid, selectedOrg],
        queryFn: async () => {
            return await groupAPI.getGroupWithDeviceUUID(uuid);
        }
    });

    if (groups.isLoading || group.isLoading || sites.isLoading) {
        return wrapper('Loading...', controller);
    }

    if (groups.error || group.error || sites.error) {
        return wrapper("An error has occurred: " + (sites?.error?.message || groups?.error?.message || group?.error?.message), controller);
    }

    if (!sites.data) {
        return wrapper('Loading...', controller);
    }

    var basic_groups_data = groups.data.map(function (group) {
        var ret = processGroupData(groups.dataUpdatedAt, group, null, showAdvancedDeviceLevel);
        return ret;
    }).filter((row) => { return typeof row.parent_id == 'undefined' });
    var group_data = group.data ? processGroupData(group.dataUpdatedAt, group.data, [selected_device.data], showAdvancedDeviceLevel) : null;
    var device_data = processDeviceData(selected_device.dataUpdatedAt, selected_device.data);

    return (
        <ClearwaysDeviceSettingsForm
            selected_device={device_data}
            sites={sites.data}
            selected_group={group_data}
            selected_subgroup={group_data ? group_data.subgroups.filter((subgroup) => { return subgroup.uuids.indexOf(uuid) > -1 })[0] : {}}
            groups={basic_groups_data}
        />
    );
}

ClearwaysDeviceSettings.propTypes = {
    uuid: PropTypes.string,
    selected_device: PropTypes.object
};

export default ClearwaysDeviceSettings;